export default {
  title: 'Playturbo',
  payment: {
    button: 'Purchase Package',
  },
  menu: {
    account: 'My Account',
    template: 'My Playable',
    logout: 'Logout',
    subscribeTips: 'Playable Production Tool',
  },
  nav: {
    delivery: 'Creative List',
    index: 'Customized Playables',
    commonTemplate: 'Playable Template Tool',
    videoImage: 'Graphic Design & Video Production',
    report: 'Report',
  },
  makerSwitch: {
    tools: 'Select tools',
    dmaker: 'Customized Creative',
    gmaker: 'Playable Production Tool',
    vmaker: 'Video Ads Production Tool',
  },
  download: {
    dropdown: ['Apply on Mintegral', 'Download For Other Networks'],
  },
  message: {
    notifications: 'System Notification',
    ignoreAll: 'Ignore All',
    viewAll: 'View All',
    noNotification: 'No Notification',
  },
}
